import * as Y from "yjs";

/**
 * Cross-tab live sync for a Y.Doc via BroadcastChannel. y-indexeddb persists
 * updates but does not push them to other open tabs; this closes that gap so
 * two tabs of the same browser stay live even fully offline.
 */
export function crossTabSync(channelName: string, doc: Y.Doc): () => void {
  const channel = new BroadcastChannel(channelName);
  const origin = `bc:${channelName}`;

  const onUpdate = (update: Uint8Array, updateOrigin: unknown) => {
    if (updateOrigin === origin) return;
    channel.postMessage(update);
  };
  doc.on("update", onUpdate);

  channel.onmessage = (e: MessageEvent) => {
    const data = e.data as ArrayBuffer | Uint8Array;
    const update = data instanceof Uint8Array ? data : new Uint8Array(data);
    Y.applyUpdate(doc, update, origin);
  };

  return () => {
    doc.off("update", onUpdate);
    channel.close();
  };
}
